export default {
  aboutPage: {
    title: "Frederic-K",
    subtitle: "Développeur de Logiciels Full-Stack",
    catchphrase:
      "Passionné par l'innovation, j'aime allier la technique, la créativité et la collaboration pour des solutions humaines.",
    summaryTitle: "Un Voyage à travers des Projets, des Défis et des Rencontres",
    summaryText:
      "Animé par une passion pour la technologie et une curiosité pour l'innovation, j'aime m'investir dans des projets qui allient expertise technique et interaction humaine. Mon parcours m'a doté d'un ensemble de compétences diversifiées, allant du développement logiciel à l'administration système et à la communication. Je m'épanouie dans le déploiement et la gestion de solutions innovantes, toujours avec un accent sur l'écoute, la collaboration et le soutien de mon entourage. Aujourd'hui, je suis impatient de canaliser mes compétences dans des projets qui m'inspirent et me défient, en créant des solutions percutantes qui résonnent avec les gens.",
    profileTitle: "Profil",
    devSkillTitle: "Technologies",
    globalSkillTitle: "Compétences",
    skillsWordCloud: "Nuage de compétences",
    referencesTitle: "Recommandations",
    references: {
      laurentReber2024: {
        text: "Monsieur Frédéric Kreuder a travaillé sous mon autorité au service Flux Entrants non Dématérialisés de l’Urssaf Alsace de 2013 à 2019 en qualité de référent technique en charge de la maîtrise de la chaîne de traitement des flux entrants, des outils et leur paramétrage. M Kreuder est un collaborateur sérieux et rigoureux, qui s'investit dans son travail, et a à cœur de mener à bien les missions qui lui sont confiées et d’atteindre les objectifs assignés. Il est également force de proposition concernant son domaine d’activité afin de trouver des simplifications et des gains de productivité. Prêt à s’investir dans de nouvelles missions, Monsieur Kreuder est motivé pour intégrer vos équipes et je vous recommande sa candidature. Je vous remercie par avance de l’attention que vous voudrez bien apporter à sa demande. Le responsable de l'administration générale de l'Urssaf Alsace",
        author: "Laurent REBER",
        date: "09/04/2024",
      },
      herveKoell2024: {
        text: "Sérieux, consciencieux ce fut agréable de travailler avec Frédéric. Des échanges conviviaux aussi bien professionnel que privé qui ont permis de faire avancer les projets dans une certaine sérénité. J'ai apprécié travailler et échanger avec lui.",
        author: "Hervé KOELL",
        date: "07/03/2024",
      },
      yousriTabbakh2023: {
        text: "J'ai eu le privilège d'assumer le rôle de mentor de Frédéric dans le cadre de sa formation en tant que Développeur React sur OpenClassrooms. Sa motivation et son désir d'acquérir de nouvelles connaissances ont dépassé mes attentes. De plus, il a réussi à développer ses compétences en programmation à un rythme remarquable. Je suis convaincu que son engagement dans les projets futurs constituera une contribution extrêmement précieuse.",
        author: "Yousri TABBAKH",
        date: "28/11/2023",
      },
    },
    programTitle: "Cursus",
    program: {
      fullStackMERN: {
        title: "Développeur Full-Stack – MERN",
        from: "Formation indépendante",
        // date: "2024",
      },
      javascriptReact: {
        title: "Développeur d'application – JavaScript React",
        from: "Openclassrooms",
        // date: "2023",
      },
      teamLeader: {
        title: "Être animateur d'équipe",
        from: "Cirfe",
        // date: "2013",
      },
      conflictManagement: {
        title: "Gestion des conflits",
        from: "Cirfe",
        // date: "2013",
      },
      BTS: {
        title: "BTS Assistant de Gestion PME/PMI",
        from: "École Commerciale Privée",
        // date: "2000",
      },
    },
    interestTitle: "Axes d'Intérêt",
    interests: {
      technology: "Technologie",
      art: "Art",
      literature: "Littérature",
      gaming: "Gaming",
      cooking: "Cuisine",
      gardening: "Jardinage",
    },
  },
  // ... other translations
}
